<div class="login-log-list-container">

  <table mat-table [dataSource]="logs">

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data Logowania </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="total"></mat-paginator>
</div>

